export default __webpack_public_path__ + "static/media/F0002.7cd000b7.png";